// extracted by mini-css-extract-plugin
module.exports = {"root":"ContactPage_root__pX_93","logoImage":"ContactPage_logoImage__9W46O","successView":"ContactPage_successView__n_TVI"};